/*
  Image upload for tour edit
  TODO - consolidate ImageUloaders into 1 component (another in Resources)
*/

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { DirectUploadProvider } from 'react-activestorage-provider';

import ReactSpinner from 'react-spinjs-fix';
import { DEFAULT_OPTS as SPINNER_OPTIONS } from 'views/anyguide/helpers/spinner';

import { t } from 'services/translation';
import RemoveIcon from 'views/ui/icons/remove-icon';
import { Theme } from 'ui_system/theme';
import { AddButton } from './FormStyles';

const Container = styled.div({
  position: 'relative',
  display: 'inline-block',
  marginBottom: '30px',
});

const Hidden = styled.div({
  display: 'none',
});

const Uploader = styled.div({});

const UploadButton = styled(AddButton)`
  line-height: 18px;
  width: 197px;
`;

const Photo = styled.div`
  width: 256px;
  height: 192px;
  margin-top: 16px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    svg {
      opacity: 1;
    }
  }
  svg {
    position: absolute;
    right: -9px;
    top: -9px;
    opacity: 0;
    transition: opacity 200ms linear;
    z-index: 1;
    cursor: pointer;
  }
  .spinner {
    z-index: 1000;
  }
`;

const Image = styled.img({
  width: '256px',
  height: '192px',
  objectFit: 'cover',
  objectPosition: 'center',
});

const ImageLabelContainer = styled.div`
  position: absolute;
  left: 8px;
  bottom: 166px;
  background-color: ${Theme.colors.darkBackground};
  width: 160px;
  text-align: center;
  border-radius: 5px;
  height: 20px;
  padding-top: 1px;
  z-index: 10;
`;
const ImageLabel = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${Theme.colors.white};
`;

const RemoveButton = styled(RemoveIcon)``;

const ImageUploader = (props) => {
  const [blobImage, setBlobImage] = useState(null);

  const uploadStarted = () => {
    props.uploadStarted();
  };

  const uploadFinished = (images) => {
    props.onUpload(images);
    // Clears the input value so onchange will still fire on same file twice in a row
    const input = document.getElementById('file');
    if (input) {
      input.value = null;
    }
  };

  const provider = (isKiosk) => {
    return (
      <DirectUploadProvider
        origin={{}}
        onSuccess={(images) => {
          uploadFinished(images);
        }}
        render={({ handleUpload, uploads, ready }) => {
          return (
            <Hidden>
              <input
                id="file"
                type="file"
                name="file"
                multiple
                value=""
                disabled={!ready}
                accept="image/*"
                onChange={(e) => {
                  if (isKiosk) {
                    generateUploadPreview(e.currentTarget.files[0]);
                  } else {
                    uploadStarted();
                  }
                  handleUpload(e.currentTarget.files);
                }}
              />
            </Hidden>
          );
        }}
      />
    );
  };

  const generateUploadPreview = (upload) => {
    const uploadedFile = URL.createObjectURL(upload);

    props.setKioskBackgroundImageBlob(uploadedFile);
  };

  const removeBackground = () => {
    props.removeBackgroundImage();
  };

  const renderKioskUploader = () => {
    const { kioskImage, removeBackgroundImage, defaultKioskBackgroundImage } =
      props;

    if (!blobImage && !kioskImage && !defaultKioskBackgroundImage)
      return renderUploader();
    return (
      <>
        {renderUploader()}
        <ImageLabelContainer>
          <ImageLabel>{t('ANYROAD_LIVE_BACKGROUND')}</ImageLabel>
        </ImageLabelContainer>
        <Photo>
          <Image src={blobImage || kioskImage || defaultKioskBackgroundImage} />
          {(blobImage || kioskImage) &&
          defaultKioskBackgroundImage != kioskImage ? (
            <RemoveButton onClick={removeBackground} />
          ) : null}
        </Photo>
      </>
    );
  };

  const renderUploader = () => {
    const { buttonColor } = props;

    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      <label htmlFor="file">
        <Uploader>
          <UploadButton color={buttonColor}>
            <i className="af-plus-ar" />{' '}
            {props.displayText || t('UPLOAD_PHOTOS')}
          </UploadButton>
        </Uploader>
      </label>
    );
  };

  const renderComponent = () => {
    const { uploaderFor } = props;
    const html = (
      <>
        {provider(false)} {renderUploader()}{' '}
      </>
    );

    if (uploaderFor && uploaderFor === 'KIOSK_IMAGE') {
      return (
        <>
          {provider(true)} {renderKioskUploader()}{' '}
        </>
      );
    }

    return html;
  };

  return <Container>{renderComponent()}</Container>;
};

export default ImageUploader;
